import { useSelector } from 'react-redux';
import { selectIotConfig } from '../services/selectors';

export const useIotConfig = () => useSelector(selectIotConfig);
